module.exports = __webpack_public_path__ + "img/united-trust-bank.f3a183b4.jpg";